// UA
const UA = navigator.userAgent.toLowerCase()

// 左侧补零
const leftPad = n => {
  return n < 10 ? `0${n}` : n
}

// 导出模块

// 运行环境
export const isWechat = /micromessenger/gi.test(UA)
export const isZaiart = /from\/zaiart/gi.test(UA)
export const isZaiartIOS = isZaiart && /platform\/iphone/gi.test(UA)
export const isZaiartAndroid = isZaiart && /platform\/android/gi.test(UA)

// 图片地址
export function getImageUrl(url, suffix, defaultUrl) {
  suffix = suffix || ''
  if (!url) {
    return (
      defaultUrl ||
      '//www.zai-art.com/appwrapper_dist/appDefaultImage/empty.png'
    )
  }
  return /(http)|(https)|(\/\/)/gi.test(url)
    ? url.replace(/(^http:)|(^https:)/gi, '') + suffix
    : '//img.zai-art.com/' + url + suffix
}

// 数据状态
export function getDataStatus(value) {
  let options = { 0: '已发布', 1: '删除', 3: '待处理', 5: '已处理', 7: '下线' }
  return options[value]
}

// 订单状态
export function getTradeStatus(value) {
  let options = {
    NONE: 'NONE',
    WAIT_PAY: '等待支付',
    CANCEL: '交易取消',
    SUCCESS: '交易成功',
    REFUNDING: '退款中',
    WAIT_SHIPMENT: '待发货',
    WAIT_CONFIRM_RECEIPT: '待收货',
    REFUNDED: '已退款'
  }
  return options[value]
}

// 内容自动换行
export function getAutoWrapContent(value) {
  return value ? value.replace(/\r\n|\n/g, '<br>') : ''
}

// 日期格式化 yyyy-mm-dd
export function formatDate(value) {
  if (!value) {
    return ''
  }
  let date = new Date(value)
  let result = `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(
    date.getDate()
  )}`
  return result
}

// 日期格式化 yyyy-mm-dd hh-mm-ss
export function formatDateTime(value) {
  if (!value) {
    return ''
  }
  let date = new Date(value)
  let result = `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(
    date.getDate()
  )} ${leftPad(date.getHours())}:${leftPad(date.getMinutes())}:${leftPad(
    date.getSeconds()
  )}`
  return result
}

// 日期格式化 d天m时s分
export function formatAutoConfirmTime(value) {
  let ts = +new Date()
  if (!value || value < ts) {
    return ''
  }
  let leftTime = (value - ts) / 1000
  let d = Math.floor(leftTime / (24 * 60 * 60))
  let h = Math.floor((leftTime / (60 * 60)) % 24)
  let m = Math.floor((leftTime / 60) % 60)
  let result = d ? `${d}天` : ''
  result += h ? `${h}时` : ''
  result += !d && !h && m ? `${m}分钟` : ''
  return result
}

// 价格+积分
export function getPriceCreditHtml(price = 0, credit = 0, text = '') {
  let result = ''
  if (text) {
    result += `<span>${text}</span>`
  }
  // 价格
  if (price || !credit) {
    result += `<span class="t1">¥</span><span class="t2">${price}</span>`
  }
  // 价格+积分
  if (price && credit) {
    result += '<span class="t1">+</span>'
  }
  // 积分
  if (credit) {
    result += price
      ? `<span class="t1">${credit}积分</span>`
      : `<span class="t2">${credit}</span><span class="t1">积分</span>`
  }
  return `${result}`
}
/**
 * 设置在艺页面title
 * @param {string} title 页面标题
 */
export function setTitle(title) {
  document.title = title
  isZaiartIOS &&
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.updateWebTitle &&
    window.webkit.messageHandlers.updateWebTitle.postMessage(title)
}

/**
 * 在艺页面跳转
 * @param {string} dataId 数据id
 * @param {string} dataType 数据类型
 * @param {string} dataTitle 数据标题
 */
export function openPage(dataId, dataType, dataTitle = '') {
  if (isZaiartAndroid) {
    window.localAndroid && window.localAndroid.innerDetailOpen(dataId, dataType)
  } else if (isZaiartIOS) {
    window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.zai_art_img &&
      window.webkit.messageHandlers.zai_art_img.postMessage([
        dataId,
        dataType,
        dataTitle
      ])
  }
}

/**
 * app网页是否显示分享菜单
 * @param {number} 1显示， 0不显示
 */
const toggleShare = function(n) {
  if (isZaiartAndroid) {
    window.android_get_share_data_js_obj &&
      window.android_get_share_data_js_obj.showShare(n)
  } else if (isZaiartIOS) {
    window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.showShare &&
      window.webkit.messageHandlers.showShare.postMessage(n)
  }
}

/**
 * app隐藏分享菜单
 */
export function hideShare() {
  toggleShare(0)
}
/**
 * app显示分享菜单
 */
export function showShare() {
  toggleShare(1)
}
/** 设置分享信息
 * @param {object} shareCard 对应的shareCard这个json字符串
 */
export function setShare(shareCard) {
  /* 定义分享页信息方法，供Android和IOS客户端进行调用 */
  window.sendShareCopy = function(strCls, strFn) {
    /* android方法调用 */
    if (strCls && strFn) {
      window[strCls][strFn](JSON.stringify(shareCard) || '')
    } else {
      /* ios方法调用 */
      return JSON.stringify(shareCard) || ''
    }
  }
}
/**
 * app打开分享
 * @param {object} shareCard
 */
export function openShare(shareCard) {
  if (isZaiartAndroid) {
    window.android_get_share_data_js_obj &&
      window.android_get_share_data_js_obj.js_to_android_direct_share(
        JSON.stringify(shareCard)
      )
  } else if (isZaiartIOS) {
    window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.share &&
      window.webkit.messageHandlers.share.postMessage(JSON.stringify(shareCard))
  }
}
/**
 * 在艺登录
 * @param {Function} callback 登录成功回调
 */
export function zaiartLogin(callback) {
  /* 统一调用方法 */
  window.zaiyi_login_callback = function(jsonStr) {
    callback(jsonStr)
  }
  /* Android */
  window.localAndroid &&
    window.localAndroid.innerWebLogin(
      JSON.stringify({
        param: {}
      })
    )
  /* IOS */
  window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.innerWebLogin &&
    window.webkit.messageHandlers.innerWebLogin.postMessage(
      JSON.stringify({
        param: {}
      })
    )
}
/* 预览图片 */
export function previewImage(index, urlList) {
  if (isZaiartAndroid) {
    window.localAndroid &&
      window.localAndroid.innerImgOpen(index, urlList.join(','))
  } else if (isZaiartIOS) {
    window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.zai_art_img &&
      window.webkit.messageHandlers.zai_art_img.postMessage([
        index,
        urlList,
        '',
        '1'
      ])
  }
}

/* 分享初始化 */
export function shareInit(options = {}) {
  let config = {
    title: options.title,
    content: options.desc,
    id: '',
    logo: options.imgUrl,
    siteUrl: options.link,
    sourceData: { dataId: options.link, dataType: 101 },
    type: 0
  }
  return {
    qq: JSON.stringify(config),
    wechat: JSON.stringify(config),
    wechatFriends: JSON.stringify(config),
    weibo: JSON.stringify(config),
    zaiart: JSON.stringify(config)
  }
}


// 判断iphoneX
export function getIsIphonex () {
  var u = navigator.userAgent;
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isIOS) {
      if (screen.height == 812 && screen.width == 375) {
          return true;
      }
      else {
          return false;
      }
  }
}
